import React, { useState, useRef,useContext } from "react";
import Slider from "react-slick";
import {
  formatIndianAmount,
  formatDaysAgo,
  addtoWishlist_Projects,
} from "../Services/Helper";
import { useNavigate } from "react-router-dom";
import SidebarFilter from "../Common/SidebarFilter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { getRecords } from "../Services/ApiCall";
import { ApiContext } from "../Context/Context";
import { LoggedInUserID } from "../Services/Urls";
import { toast } from "react-toastify";
import { PostRecords } from "../Services/ApiCall";
const images = [
  "https://picsum.photos/id/1011/800/500",
  "https://picsum.photos/id/1012/800/500",
  "https://picsum.photos/id/1013/800/500",
  "https://picsum.photos/id/1015/800/500",
  "https://picsum.photos/id/1016/800/500",
];

const ProjectsHome = ({ onheartClick, ...data }) => {
      const {
      logindata,
      setlogindata,
      userData,
      setuserData,
      coordinates,
      setcoordinates,
  
      searchData,
      setsearchData,wishlist, setWishlist
    } = useContext(ApiContext);
  const [open, setOpen] = useState(false);

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const mainSettings = {
    asNavFor: nav2,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    swipeToSlide: true,
    slidesToScroll: 1,
    beforeChange: (_, next) => setActiveIndex(next),
  };

  const thumbSettings = {
    asNavFor: nav1,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    swipeToSlide: true,
    infinite: true,
    arrows: false,
  };
  const [activeIndex, setActiveIndex] = useState(0);

  const navigate = useNavigate();

  const defaultImage = "assets/img/property/property-22.jpg";

  const imageSrc =
    typeof data?.Images === "string" && data.Images.trim() !== ""
      ? data.Images.split(",").map((img) => img.trim())
      : images;

  const totalImages = imageSrc?.length;

  const handleNavigate = () => {
    navigate(`/project-details?id=${data?.SocietyID}`);
  };

  const [viewMobile, setviewMobile] = useState(false);

  const [devMobile, setdevMobile] = useState("");

  const getDevMobile = () => {
    getRecords(
      417,
      1,
      `{DeveloperID: { $in: [${data?.DeveloperID}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            //console.log(data?.response?.records[0]?.ContactNumber);
            setdevMobile(data?.response?.records[0]?.ContactNumber);
          } else {
            console.log("Error in fetching featured properties", data);
          }
        }
      },
    );
  };

    const isWishlisted = (data) => {
    return wishlist.some(
      (item) => item.ListingID === data?.SocietyID && item.IsListingID == 2,
    );
  };


  return (
    <>
      <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-xs-12">
        <div className="property-card style2 pscard d-flex listpro prolist projectlist">
          <div
            className="property-img-slider property-img"
            style={{ width: "35%", position: "relative" }}
          >
            {/* <img src={imageSrc} alt="Property" /> */}

            <span className="timages">
              {activeIndex + 1} / {totalImages}
            </span>
            <Slider {...sliderSettings}>
              {imageSrc?.map((img, index) => (
                <div key={index}>
                  <img
                    src={img}
                    alt={`slide-${index}`}
                    style={{
                      width: "100%",
                      height: "280px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              ))}
            </Slider>
            {/* <div style={{ textAlign: "right"}} className="vimages">
                        <Button
                          variant="outlined"
                          onClick={() => setOpen(true)}
                          className="vallimages"
                        >
                          View All Images
                        </Button>
                      </div> */}
            {data?.FeaturedID == 1 && (
              <div className="chipps">
                <span className="property-condo">Featured</span>
              </div>
            )}

            <span className="property-status">
              {" "}
              <i
                onClick={(e) => {
                  e.stopPropagation(); // prevents parent click

                  if (LoggedInUserID == null) {
                    onheartClick();
                  } else {

                    if (!isWishlisted(data)) {
                      let enqBody = [
                        {
                          ListingID: data?.SocietyID,
                          PropertyTypeID: 1,
                          VerticalID: 4,

                         
                          UserName: userData?.User,
                          UserID: userData?.UserID,
                          UserMobile: userData?.Mobile,
                          Remarks: `Wishlist Enquiry For Project - ${data?.Society} `,
                        },
                      ];

                      PostRecords(425, 1, enqBody, (data) => {
                        if (data.hasErrors === false) {
                          toast.success("Enquiry Sent Successfully");
                        } else {
                          toast.error("Error in sending Enquiry");
                        }
                      });
                    }


                    addtoWishlist_Projects(data, wishlist, setWishlist);
                  }
                }}
                style={{
                  color: isWishlisted(data) ? "red" : "#ccc", 
                }}
                className="ri-heart-fill"
              />
            </span>
          </div>
          <div className="property-info" style={{ width: "65%" }}>
            <h3 className="d-flex">
              <a href="#">{data.Society}</a>

              <div className="chipps chp chpp">
                <span className="bg-green">{data?.ProjectStatus}</span>
              </div>
            </h3>
            <small>
              {data.City}, {data?.Locality}
            </small>
            <p className="property-price mb-2">₹ {data.PriceRange} </p>
            <small className="d-mobile">
              <b>4, 5 BHK</b>
            </small>
            <small className="d-desk">
              <b>Highlights :</b>
            </small>
            <small style={{ display: "block" }}>
              {data?.PropertyAmenities?.slice(0, 3)
                .map((amenity) => amenity?.PropertyAmenities)
                .join(", ")}
            </small>
            <small style={{ fontWeight: 600 }} className="projectoverview">
              {data?.ProjectOverview?.slice(0, 150)}...
            </small>
            {/* <span className="property-status">{formatDaysAgo(data.cDt)}</span> */}
            {/* <p>
            <i className="flaticon-location" />
            {data.City}, {data.Area}
          </p> */}

            {/* <div className="headss">
            <ul
              className="property-metainfo list-style lst1"
              style={{ marginTop: 10, whiteSpace: "nowrap" }}
            >
             {Array.isArray(data?.PropertyAmenities) &&
                data?.PropertyAmenities?.length > 0 &&
                data?.PropertyAmenities?.slice(0, 3)?.map((amenity, index) => (
                  <li key={index}>
                    <img
                      src={amenity?.PropertyAmenitiesIcon}
                      alt="Furniture"
                      style={{ height: 20, width: 20 }}
                      // className="furnishing-icon"
                    />
                   
                  </li>
                ))}
            </ul>
          
          </div> */}
            {/* <div className="property-status-wrap" style={{ marginBottom: 5 }}>
            
              <span className="property-status">{formatDaysAgo(data.cDt)}</span>
            </div> */}

            <div className="flxxs">
              <div> by {data.DeveloperName}</div>
              <div>
                {" "}
                <small className="">{formatDaysAgo(data.cDt)}</small>
              </div>
            </div>

            <div className="d-flexx border-top pdt-10 detailblockks">
              <div className="d-desk">
                <div
                  className="d-flex"
                  style={{ alignItems: "center", whiteSpace: "nowrap" }}
                >
                  <small className="">{formatDaysAgo(data.cDt)}</small>
                  {/* <div className="chipps chp">
                    <span className="bg-red">FEATURED DEVELOPER</span>
                  </div> */}
                </div>

                <small style={{ marginLeft: 2 }} className="developer devs">
                  by {data.DeveloperName}
                </small>
              </div>

              <div style={{ textAlign: "right" }} className="alignbtn">
                {/* <a onClick={() =>{setviewMobile(!viewMobile);
                  getDevMobile()
                }} className="btn style1">{viewMobile ? devMobile : "View Number"}</a> */}

                <a onClick={handleNavigate} className="btn style3">
                  View Details
                </a>
                {/* <button type="" className="btn style3">
                  {" "}
                  Download
                </button> */}
                {/* <button type="" className="btn style3">
                  <i className="ri-heart-line" />
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <IconButton
          onClick={() => setOpen(false)}
          style={{ position: "absolute", right: 8, top: -3, zIndex: 9999 }}
        >
          x
        </IconButton>

        <DialogContent style={{ padding: 0, overflowY: "clip" }}>
          <Box position="relative">
            <Box
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 2,
                background: "rgba(0,0,0,0.6)",
                color: "#fff",
                padding: "4px 10px",
                borderRadius: "12px",
                fontSize: 14,
              }}
            >
              {activeIndex + 1} / {totalImages}
            </Box>

            {/* Main Slider */}
            <Slider {...mainSettings} ref={(s) => setNav1(s)}>
              {images.map((img, index) => (
                <Box key={index}>
                  <img
                    src={img}
                    alt=""
                    style={{
                      width: "100%",
                      height: 400,
                      objectFit: "cover",
                      borderRadius: 0,
                    }}
                  />
                </Box>
              ))}
            </Slider>

            {/* Thumbnail Slider */}
            <Box mt={2}>
              <Slider {...thumbSettings} ref={(s) => setNav2(s)}>
                {images.map((img, index) => (
                  <Box key={index} px={0.5}>
                    <img
                      src={img}
                      alt=""
                      style={{
                        width: "100%",
                        height: 80,
                        objectFit: "cover",
                        borderRadius: 0,
                        cursor: "pointer",
                        border:
                          activeIndex === index
                            ? "2px solid #1976d2"
                            : "2px solid transparent",
                      }}
                    />
                  </Box>
                ))}
              </Slider>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ProjectsHome;
